import avatarBank from './avatarBank.jpg';
import warningIcon from './warningIcon.svg';
import integratedSolutionImage from './integratedSolutionImage.jpg';
import planTitleBrand from './planTitleBrand.svg';
import walkthroughOverlayPdfBg from './walkthroughOverlayPdfBg.svg';
import izibiziImage from './iziBizi.jpg';
import selectedPlanTotalConclusion from './selectedPlanTotalConclusion.png';
import selectedPlanStartedConclusion from './selectedPlanStartedConclusion.png';
import check from './check.svg';
import successCircle from './successCircle.svg';

export const imagesBcp = {
	avatarBank,
	integratedSolutionImage,
	warningIcon,
	planTitleBrand,
	walkthroughOverlayPdfBg,
	izibiziImage,
	selectedPlanTotalConclusion, //this image still here until we have the animation for this image;
	selectedPlanStartedConclusion, //this image still here until we have the animation for this image;
	check,
	successCircle,
};
